module.exports = __webpack_public_path__ + "static/media/3.34129b37.jpg";